// resizes an image blob to different dimensions via off-screen canvas
export const resizeImage = async (image: Blob, size: number, type: string): Promise<Blob> => {
  // use an explicit promise since we'll have two callback-based APIs to deal with
  return new Promise<Blob>((resolve, reject) => {
    const img = document.createElement('img');
    img.src = URL.createObjectURL(image);
    // continue when the image is actually loaded
    img.onload = () => {
      // fit SHORTEST side to the desired size 
      const originalWidth = img.naturalWidth;
      const originalHeight = img.naturalHeight;
      let width: number, height: number;
      if (originalWidth > originalHeight) {
        height = size;
        width = originalWidth * (size / originalHeight);
      } else {
        width = size;
        height = originalHeight * (size / originalWidth);
      }

      // render to canvas
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d')!;
      ctx.drawImage(img, 0, 0, width, height);
      // continue when rendered to image blob
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(img.src);
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error("Failed to resize image via canvas"));
        }
      }, type)
    };
  });
};

// creates a JPEG thumbnail from the first frame of a video via off-screen canvas
export const createVideoThumbnail = async (video: Blob): Promise<Blob> => {
  // use an explicit promise since we'll have two callback-based APIs to deal with
  return new Promise<Blob>((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const videoEl = document.createElement('video');
    videoEl.autoplay = true;
    videoEl.muted = true;
    videoEl.src = URL.createObjectURL(video);

    // continue when video is actually loaded    
    videoEl.onloadeddata = () => {
      const ctx = canvas.getContext("2d")!;
      canvas.width = videoEl.videoWidth;
      canvas.height = videoEl.videoHeight;
      ctx.drawImage(videoEl, 0, 0, videoEl.videoWidth, videoEl.videoHeight);
      videoEl.pause();
      // continue when rendered to image blob
      canvas.toBlob((blob) => {
        URL.revokeObjectURL(videoEl.src);
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error("Failed to create video thumbnail via canvas"));
        }
      }, 'image/jpeg')
    };
  });
};